import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        {/* Brand and Description */}
        <div style={styles.section}>
          <h3 style={styles.brand}>RESUMEFUEL</h3>
          <p style={styles.description}>
            Build professional resumes and CVs in minutes. No design skills needed — just choose, customize, and download.
          </p>
        </div>

        {/* Main Menu */}
        <div style={styles.section}>
          <h4 style={styles.sectionTitle}>Main Menu</h4>
          <ul style={styles.linkList}>
            <li><Link to="/" style={styles.link}>Home</Link></li>
            <li><Link to="/about" style={styles.link}>About</Link></li>
            <li><Link to="/pricing" style={styles.link}>Pricing</Link></li>
            <li><Link to="/contact" style={styles.link}>Contact</Link></li>
          </ul>
        </div>

        {/* Quick Links */}
        <div style={styles.section}>
          <h4 style={styles.sectionTitle}>Quick Links</h4>
          <ul style={styles.linkList}>
            <li>
              <Link to="/terms" style={styles.link}>
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link to="/privacy" style={styles.link}>Privacy Policy</Link>
            </li>
            <li>
              <Link to="/disclaimer" style={styles.link}>
                Disclaimer
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Copyright */}
      <div style={styles.bottomBar}>
        <p style={styles.copy}>
          © {new Date().getFullYear()} <strong>resumefuel.xyz</strong>. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    backgroundColor: "rgb(14 40 62)",
    color: "#fff",
    padding: "40px 20px 20px",
    fontSize: "14px",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    maxWidth: "1100px",
    margin: "0 auto",
    gap: "30px",
  },
  section: {
    flex: "1 1 250px",
  },
  brand: {
    fontSize: "22px",
    marginBottom: "10px",
    color: "#ffffff",
    fontWeight: "bold",
  },
  description: {
    color: "#ccc",
    lineHeight: "1.6",
    fontSize: "14px",
  },
  sectionTitle: {
    fontSize: "16px",
    marginBottom: "10px",
    fontWeight: "bold",
    color: "#fff",
  },
  linkList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    lineHeight: "2",
  },
  link: {
    color: "#fff",
    textDecoration: "none",
    fontSize: "14px",
  },
  bottomBar: {
    marginTop: "30px",
    borderTop: "1px solid #333",
    paddingTop: "15px",
    textAlign: "center",
  },
  copy: {
    fontSize: "13px",
    color: "#aaa",
  },
};

export default Footer;
